/*
 * Artists index: search, and the A to Z bar following the page.
 * sections/pg-artists-index.liquid. The page works without this file: every
 * artist is already a link, and A to Z is plain anchor links. The search box
 * is rendered `hidden` and only revealed here, so nobody sees a dead control.
 */
(() => {
  const root = document.querySelector("[data-pga]");
  if (!root) return;

  const fold = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .trim();

  const items = [...root.querySelectorAll("[data-pga-name]")].map((el) => ({ el, name: fold(el.dataset.pgaName) }));
  const letters = [...root.querySelectorAll("[data-pga-letter]")];
  const boxes = [...root.querySelectorAll(".pga-tiles, .pga-ones")];
  const top = root.querySelector("[data-pga-top]");
  const empty = root.querySelector("[data-pga-empty]");
  const searchWrap = root.querySelector("[data-pga-search]");
  const input = root.querySelector("[data-pga-q]");
  const azRow = root.querySelector("[data-pga-az-row]");

  // ---- search ----
  function apply() {
    const q = fold(input.value);
    for (const it of items) it.el.hidden = q !== "" && !it.name.includes(q);
    if (top) top.hidden = q !== "";
    for (const box of boxes) box.hidden = !box.querySelector("[data-pga-name]:not([hidden])");
    let shown = 0;
    for (const sec of letters) {
      const any = !!sec.querySelector("[data-pga-name]:not([hidden])");
      sec.hidden = !any;
      if (any) shown++;
    }
    if (!empty) return;
    empty.hidden = q === "" || shown > 0;
    if (!empty.hidden) {
      // Built from nodes, never innerHTML: this is the visitor's own text.
      const typed = input.value.trim();
      const link = document.createElement("a");
      link.href = "/search?type=product&q=" + encodeURIComponent(typed);
      link.textContent = "Search all our puzzles for it";
      empty.replaceChildren(document.createTextNode("No artist matches “" + typed + "”. "), link, document.createTextNode("."));
    }
  }

  if (searchWrap && input) {
    searchWrap.hidden = false;
    let frame = 0;
    input.addEventListener("input", () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(apply);
    });
  }

  // ---- A to Z follows the page ----
  if (azRow && "IntersectionObserver" in window) {
    const links = new Map([...azRow.querySelectorAll("a[data-pga-l]")].map((a) => [a.dataset.pgaL, a]));
    let current = null;
    const io = new IntersectionObserver(
      (entries) => {
        for (const en of entries) {
          if (!en.isIntersecting) continue;
          const a = links.get(en.target.dataset.pgaLetter);
          if (!a || a === current) continue;
          if (current) current.classList.remove("is-on");
          a.classList.add("is-on");
          current = a;
          // Keep the lit letter visible on a phone, where the bar scrolls sideways.
          const left = a.offsetLeft - azRow.clientWidth / 2 + a.clientWidth / 2;
          azRow.scrollTo({ left, behavior: "auto" });
        }
      },
      { rootMargin: "-25% 0px -65% 0px" },
    );
    letters.forEach((sec) => io.observe(sec));
  }
})();
